import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { GenericService } from 'src/app/services/generic.service';
import * as L from 'leaflet';


@Component({
  selector: 'app-approval',
  templateUrl: './approval.component.html',
  styleUrls: ['./approval.component.css']
})
export class ApprovalComponent implements OnInit {

  form: any | FormGroup
  modelSubtitle = false
  checked = false
  name = ""
  version = ""
  isActive = false
  data: any = [];
  prospectdata: any = [];
  prospectid: any = "";
  private map!: L.Map;
  private centroid: L.LatLngExpression[]= [[17.3850, 78.4867]];

  pageNumber: number = 0;
  totalRecords: number = 0;
  recordsPerPage:number = 10;
  tableSize: number = 10;
  first: number = 0;
  isLoading: any = false

  actionControls: any = {
    isAdd: false, 
    isView: false, 
    isDelete: false, 
    isModify: false 
  }
  cid: any;
  searchFilter: string = "";

  constructor(private fb: FormBuilder,private toastr: ToastrService,private generic_service: GenericService) { }

  ngOnInit(): void {


  let href:any = window.location.href;
  let messages = href.split('/') 
  let action: any = this.generic_service.checkActionControls(messages[messages.length-1])
  this.actionControls = action
  this.getByStatusWithPagination(this.pageNumber,this.recordsPerPage)
  this.form = this.fb.group({
      applicationFormFor: [''],
      applicationName: [''],
      applicantEmailId: [''],
      applicantMobileNo: [''],
    })  
    this.cid = sessionStorage.getItem('cid')

  }

  approval(){
    let body = {
      "note": "",
      "status": "APPROVED",
      "updatedDate": 0
    }

    console.log(body)
    this.generic_service.addApproval(this.prospectid,body).subscribe(
      (response:any)=>{
        console.log(response)
        this.getByStatusWithPagination(this.pageNumber,this.recordsPerPage)
        this.toastr.success("Successfully Approved");
        this.addCustomerInfo()
        this.cancelModel()
      },
      (err:any)=>{
        console.log(err)
        this.toastr.error(err.error.errors[0].description);
      },
    )
  }

  rejection(){
    let body = {
      "note": "",
      "status": "REJECTED",
      "updatedDate": new Date().getDate
    }

    console.log(body)
    this.generic_service.addReject(this.prospectid,body).subscribe(
      (response:any)=>{
        console.log(response)
        this.getByStatusWithPagination(this.pageNumber,this.recordsPerPage)
        this.toastr.success("Successfully Rejected");
        this.cancelModel()
      },
      (err:any)=>{
        console.log(err)
        this.toastr.error(err.errors[0].description);
      }
    )
  }

  onTableDataChange(event: any) {
    this.pageNumber = event.page;
    this.getByStatusWithPagination(this.pageNumber,this.recordsPerPage)
  }


  // onTableDataChange(event: any) {
  //   this.pageNumber = event.page;

  //   if(this.searchFilter != ""){
  //     this.getAllProspectRegistrationWildSearchWithPagination(this.pageNumber,this.recordsPerPage)
  //   }else{
  //     this.getAllProspectRegistrationWithPagination(this.pageNumber,this.recordsPerPage)
  //   }
  // }

  refreshAll(){
    this.pageNumber = 0
    this.first = 0
    this.searchFilter = ""
    this.getByStatusWithPagination(this.pageNumber,this.recordsPerPage)

  }

  getAllProspectRegistrationWildSearchWithPagination(pageNumber: any,recordsPerPage: any){
   if(this.searchFilter == "" || this.searchFilter == null){
      return
    }

    this.isLoading = true

    this.generic_service.getAllProspectRegistrationWildSearchWithPagination(this.searchFilter,pageNumber,recordsPerPage).subscribe(
      (response:any)=>{
        for(let list of response.response.prospectRegistrationList){
          let applicationFormFor: any = ""
          let fatherHusbandName: any = ""
          let noOfCableConnection: any = ""
          let noOfInternetConnection: any = ""
          let identityProofType: any = ""
          let termsOfPayment: any = ""
          let bookedBy: any = ""
          let agentName: any = ""
          let identityProofAttachmentURL: any = ""
          let customerId: any = ""

          if(list.keyValuePairs != null){
            for(let key of list.keyValuePairs){
              if(key.key == "Application Form For"){
                applicationFormFor = key.value
              }

              if(key.key == "Father/Husband Name"){
                fatherHusbandName = key.value
              }

              if(key.key == "No Of Cable Connection"){
                noOfCableConnection = key.value
              }

              if(key.key == "No Of Internet Connection"){
                noOfInternetConnection = key.value
              }

              if(key.key == "Identity Proof Type"){
                identityProofType = key.value
              }

              if(key.key == "Terms Of Payment"){
                termsOfPayment = key.value
              }

              if(key.key == "Booked By"){
                bookedBy = key.value
              }

              if(key.key == "Agent Name"){
                agentName = key.value
              }

              if(key.key == "Identity Proof AttachmentURL"){
                identityProofAttachmentURL = key.value
              }

              if(key.key == "customerId"){
                customerId = key.value
              }
            }
          }

          list.applicationFormFor = applicationFormFor
          list.fatherHusbandName = fatherHusbandName
          list.noOfCableConnection = noOfCableConnection
          list.noOfInternetConnection = noOfInternetConnection
          list.identityProofType = identityProofType
          list.termsOfPayment = termsOfPayment
          list.bookedBy = bookedBy
          list.agentName = agentName
          list.identityProofAttachmentURL = identityProofAttachmentURL
          list.customerId = customerId
        }
        this.data = response.response.prospectRegistrationList;
        this.totalRecords = response.response.totalRecords;
        console.log(response)
        this.isLoading = false

      }
    )



  }

  cancelModel(){
    document.getElementById("closeModalButton")?.click()
    document.getElementById("closeModalButton1")?.click()
    this.map.remove();
  }

  getByStatusWithPagination(pageNumber: any,recordsPerPage: any){
    this.isLoading = true

    this.generic_service.getByStatusWithPagination("VERIFIED",pageNumber,recordsPerPage).subscribe(
      (response:any)=>{
        // this.data = response.response.prospectRegistrationList;
        // console.log(response)
        // this.totalRecords = response.response.totalRecords;
        // this.isLoading = false

                for(let list of response.response.prospectRegistrationList){
          let applicationFormFor: any = ""
          let fatherHusbandName: any = ""
          let noOfCableConnection: any = ""
          let noOfInternetConnection: any = ""
          let identityProofType: any = ""
          let termsOfPayment: any = ""
          let bookedBy: any = ""
          let agentName: any = ""
          let identityProofAttachmentURL: any = ""
          let customerId: any = ""

          if(list.keyValuePairs != null){
            for(let key of list.keyValuePairs){
              if(key.key == "Application Form For"){
                applicationFormFor = key.value
              }

              if(key.key == "Father/Husband Name"){
                fatherHusbandName = key.value
              }

              if(key.key == "No Of Cable Connection"){
                noOfCableConnection = key.value
              }

              if(key.key == "No Of Internet Connection"){
                noOfInternetConnection = key.value
              }

              if(key.key == "Identity Proof Type"){
                identityProofType = key.value
              }

              if(key.key == "Terms Of Payment"){
                termsOfPayment = key.value
              }

              if(key.key == "Booked By"){
                bookedBy = key.value
              }

              if(key.key == "Agent Name"){
                agentName = key.value
              }

              if(key.key == "Identity Proof AttachmentURL"){
                identityProofAttachmentURL = key.value
              }

              if(key.key == "customerId"){
                customerId = key.value
              }
            }
          }

          list.applicationFormFor = applicationFormFor
          list.fatherHusbandName = fatherHusbandName
          list.noOfCableConnection = noOfCableConnection
          list.noOfInternetConnection = noOfInternetConnection
          list.identityProofType = identityProofType
          list.termsOfPayment = termsOfPayment
          list.bookedBy = bookedBy
          list.agentName = agentName
          list.identityProofAttachmentURL = identityProofAttachmentURL
          list.customerId = customerId
        }
        this.data = response.response.prospectRegistrationList;
        this.totalRecords = response.response.totalRecords;
        console.log(response)
        this.isLoading = false

      }
    )
  }

  getProspectByID(id:any){
    this.prospectid = id
    this.generic_service.getProspectByID(id).subscribe(
      (res:any)=>{
        this.prospectdata = [];
        console.log(res);
        this.prospectdata.push(res.response);
        this.centroid.push(
          [res.response.latitude,res.response.longitude]
        )
      }
    )
  }

  open() {
    this.modelSubtitle = true;
  }

  close() {
    this.modelSubtitle = false;
    this.name = ""
    this.version = ""
    this.isActive = false
  }

  addCustomerInfo(){
    let body = {
      "version": 0,
      "isActive": true,
      "description": "",
      "name": String(this.prospectdata[0].applicationName),
      "address": String(this.prospectdata[0].installationAddress),
      "geoAddress": {
        "latitude": "",
        "longitude": ""
      },
      "mobileNo1": String(this.prospectdata[0].applicantMobileNo),
      "mobileNo2": "",
      "emailId": String(this.prospectdata[0].applicantEmailId),
      "customerParamEntityList": [],
      "status": [
        {
          "customerRegistrationStatus": "APPROVED",
          "updatedDate": 0
        }
      ],
      "latestStatus": "APPROVED",
      "image": "",
      "documents": [
        String(this.prospectdata[0].identityProofAttachmentURL),
        String(this.prospectdata[0].photoAttachmentURL)
      ],
      "cid": this.cid
    }
    this.generic_service.addCustomerInfo(body).subscribe(
      (response:any)=>{
        console.log(response)
      },
      (err:any)=>{
        console.log(err)
      }
    )
  }

}